"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BPVRapport = require("./BPVRapport");

Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BPVRapport).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }